import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { TQuestionDB, TQuestionUI, TVideoLinkDB, TVideoLinkUI } from 'data/types/faq.types';
import { questionsListConverter, videoLinksListConverter } from 'data/converters/faq.converters';
import { authSplitApi } from '../helpers/slice.helpers';

const basePMUrl = `${EPropertyMangerUrl.PROPERTY_MANAGER}/faq`;

export const faqApi = authSplitApi('faq', ['faq-question', 'faq-videlinks']).injectEndpoints({
  endpoints: (build) => ({
    getPmQuestions: build.query<TQuestionUI[], void>({
      query() {
        return {
          url: `${basePMUrl}/question`,
          method: 'GET',
        };
      },
      transformResponse: (data: TQuestionDB[]) => {
        return questionsListConverter.fromDb(data);
      },
      providesTags: ['faq-question'],
    }),

    getPmVideoLinks: build.query<TVideoLinkUI[], void>({
      query() {
        return {
          url: `${basePMUrl}/video`,
          method: 'GET',
        };
      },
      transformResponse: (data: TVideoLinkDB[]) => {
        return videoLinksListConverter.fromDb(data);
      },
      providesTags: ['faq-videlinks'],
    }),
  }),
});

export const { useGetPmQuestionsQuery, useGetPmVideoLinksQuery } = faqApi;
